import React from 'react';

import { Link as RouterLink } from 'react-router-dom';

import { useTheme } from '@mui/material/styles';
import { Box, Container, Link, Typography } from '@mui/material';

const Footer: React.FC = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                backgroundColor: theme.palette.background.paper,
                borderTop: `solid ${theme.palette.divider} 1px`,
                py: 4,
            }}
        >
            <Container maxWidth="md" sx={{ display: 'flex', gap: 3 }}>
                <Typography variant="subtitle2" color="textSecondary">
                    <Link href="https://www.novasystems.com/" target="_blank">
                        Nova Systems
                    </Link>{' '}
                    | © NovaSystems2022
                </Typography>

                <Box
                    sx={{
                        display: 'flex',
                        gap: 2,
                        justifyContent: 'space-around',
                    }}
                >
                    <Typography variant="subtitle2" color="textSecondary">
                        <Link to="/" component={RouterLink}>
                            NAIGS Home
                        </Link>
                    </Typography>

                    <Typography variant="subtitle2" color="textSecondary">
                        <Link
                            href="https://www.novasystems.com/au/privacy-policy"
                            target="_blank"
                        >
                            Privacy
                        </Link>
                    </Typography>

                    <Typography variant="subtitle2" color="textSecondary">
                        <Link
                            href="https://www.novasystems.com/au/terms-and-conditions"
                            target="_blank"
                        >
                            Terms and Conditions
                        </Link>
                    </Typography>

                    <Typography variant="subtitle2" color="textSecondary">
                        <Link
                            href="https://www.novasystems.com/au/contact-us"
                            target="_blank"
                        >
                            Contact Us
                        </Link>
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

Footer.displayName = 'Footer';
export default Footer;
